import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";

function Deposit() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Financing"
          title={`
             <div style=" align-items: baseline;">
            Syndication
                <span className="jumbotron-subtitle-2">
                 Financing
                    </span>
            </div>`}
          buttonText="Reach out to us!"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              At alrajhi bank Malaysia, we believe in keeping client’s needs as
              a priority. For large value financing of which we are unable to
              support due to Single Customer Limit, we typically set up a
              Syndication or Club deal financing arrangement to ensure Client
              requirements are fulfilled.
            </p>
            <p>
              We actively source for syndicated financing opportunities from
              partner financial institutions. Our primary focus is Malaysia and
              selective key areas across the region.
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Deposit;
